import React from 'react';
import { Modal, SparkModalPortal, Text } from '@spark';
import { unknownLabelsWarningCopy } from './labelMappingWarnings';

/**
 * Confirm Next when Select Label / Select Entity still shows the
 * "not in the task definition" warning icon.
 */
const UnknownLabelsWarningModal = ({ open, sources, isNer, onCancel, onContinue }) => {
    if (!open) return null;
    const { title, body } = unknownLabelsWarningCopy({ sources, isNer });
    return (
        <SparkModalPortal
            open
            onClose={onCancel}
            size="text"
            className="cw-dc-benchmark-modal-portal"
        >
            <Modal
                title={title}
                feedbackType="warning"
                showSubtitle={false}
                showScrollBar={false}
                showOverlay={false}
                fixedHeight={false}
                primaryLabel="Continue Anyway"
                primaryDisableWhenReadOnly
                tertiaryLabel="Cancel"
                onPrimaryClick={onContinue}
                onTertiaryClick={onCancel}
                onCloseClick={onCancel}
                className="cw-dc-benchmark-modal"
            >
                <Text variant="base-regular" color="secondary" as="p">
                    {body}
                </Text>
            </Modal>
        </SparkModalPortal>
    );
};

export default UnknownLabelsWarningModal;
